import { message } from 'antd';
import { getList, pushMeeting, delMeeting } from '../../../../services/meetingManage/dataManagement';

const initState = {
  list: [],
  queries: {}, // 搜索条件
  // 分页信息
  pageInfo: {
    page: 1,
    totalElements: 1,
    totalPages: 1,
  },
  // 加载信息
  spinProps: {
    spinning: false,
    tip: '加载中...',
  },
  // expand: false,
};

export default {
  namespace: 'dataManagement',

  state: initState,

  effects: {
    // 获取列表信息
    *fetchList({ params }, { call, put }) {
      try {
        yield put({
          type:'save',
          payload:{
            spinProps: {
              spinning:true,
              tip:'加载中'
            }
          }
        })
        const response = yield call(getList, params);

        const { content, page, totalElements,  totalPages } = response;
        yield put({
          type: 'save',
          payload: {
            list: content,
            pageInfo: {
              page,
              totalElements,
              totalPages,
            },
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });

      }
    },

    // 发布会议
    *fetchPushMeeting({ params, callback }, { call, put }) {
      try {
        yield call(pushMeeting, params);
        message.success('发布成功')
        if(callback){
          callback()
        }
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });

      }
    },

    // 删除会议
    *fetchDelMeeting({ params, callback }, { call, put }) {
      try {
        yield call(delMeeting, params);
        message.success('删除成功')
        if(callback){
          callback()
        }
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });

      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState };
    },
  },
};
